import { render, staticRenderFns } from "./MySends.vue?vue&type=template&id=48ba802a&"
import script from "./MySends.vue?vue&type=script&lang=js&"
export * from "./MySends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports